import React, { useState, useEffect } from "react";
import InfiniteScrollContainer from "../../../../components/InfiniteScroll/InfiniteScroll";
import CustomCard from "../../../../components/Card";
import CustomChip from "../../../../components/Chip";
import moment from "moment";
import BaseToggle from "./BaseToggle";
import CustomButton from "../../../../components/AddButton";
import DocumentUpload from "../components/Upload";
import SecureImage from "../../../../components/BucketImage/Image";
import CircularProgress from "../../../../components/DaysProgress";
import ContainerStatus from "./ContainerStatus";
import SurveyorDetails from "./SurveyorDetails";
import { edit, Plus, map, placeMareker } from "../../../../common/svg";
import CargoDetails from "./CargoDetails";
import SimpleTripMap from "../../../../components/TripMap/SimpleTripMap";
import { ApiService } from "../../../../service/api.service";
import { MASTER_URL } from "../../../../common/common";

import DeliveryTimeline from "../../../../components/DeliveryTimeline";
interface ContainerDetailsProps {
  container: any;
  setContainer: React.Dispatch<React.SetStateAction<any>>;
  trackingUrl?: string;
  tripId?: string;
}

const ContainerDetails: React.FC<ContainerDetailsProps> = ({
  container,
  setContainer,
  trackingUrl,
  tripId,
}) => {
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [activeCardIndex, setActiveCardIndex] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  // NEW STATE FOR LIVE TRACKING
  const [isBlurred, setIsBlurred] = useState(true);
  const [vehicleData, setVehicleData] = useState<any>(null);

  const handleViewBookingDetails = (index: number, item: any) => {
    setActiveCardIndex(index);
    setSelectedItem(item);
  };

  const fetchMoreData = async () => {
    if (!hasMore || isFetching) return;

    setIsFetching(true);

    // Implement your API call logic here
    // ...

    setIsFetching(false);
  };
  const [isEditing, setIsEditing] = useState(false);
  const [routeInfo, setRouteInfo] = useState({
    code: "EN14245",
    start: "Chennai Manali Yard",
    end: "Ennore Port",
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parts = value.split(" – "); // Split input by " – "

    if (parts.length === 3) {
      setRouteInfo({
        code: parts[0],
        start: parts[1],
        end: parts[2],
      });
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // NEW FUNCTION FOR LIVE MAP
  const ShowMap = async () => {
    try {
      setIsBlurred(false);
      console.log("🗺️ Showing live cargo map");
    } catch (error) {
      console.error("Error showing map:", error);
    }
  };
  return (
    <div className="flex flex-row w-full gap-4">
      {/* Left side - Cards list */}
      <div className="w-[400px] flex-shrink-0">
        <InfiniteScrollContainer
          width="100%"
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          isFetching={isFetching}
        >
          <div className="flex flex-col">
            {container?.map((item: any, index: number) => (
              <CustomCard
                key={index}
                onClick={() => handleViewBookingDetails(index, item)}
                isActive={activeCardIndex === index}
                className="w-full shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded mb-4"
              >
                <div className="gap-[-1]">
                  {/* Top Section: Container ID and Status */}
                  <div className="flex justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <p className="font-semibold">{item.id || `MASK${Math.random().toString().slice(2, 13)}`}</p>
                      <CustomChip
                        text={index === 0 ? "Ongoing" : "Completed"}
                        textColor={index === 0 ? "#FF973C" : "#04D900"}
                        backgroundColor={index === 0 ? "#FFF5EC" : "#ECFFEB"}
                        borderColor={index === 0 ? "#FF973C" : "#04D900"}
                      />
                    </div>
                    <p className="font-[400] text-[14px]">#{String(index + 1).padStart(2, '0')}</p>
                  </div>

                  {/* Container Details */}
                  <div className="flex justify-between">
                    <div className="leading-[18px] flex flex-col items-start">
                      <div className="flex items-center mt-2">
                        <span>{index === 0 ? "Empty to Warehouse" : "Warehouse to Port"}</span>
                        <span className="ml-5 font-medium">Trip Name</span>
                      </div>

                      <p className="font-poppins font-normal italic text-[15px] mt-1">
                        30 July 2024, 06:16pm
                      </p>

                      <div className="flex items-center gap-2 mt-1">
                        <span className="text-sm text-gray-600">Liner Name</span>
                        <span className="text-sm font-medium text-gray-800">Liner Name</span>
                      </div>
                    </div>
                    <div className="flex items-center flex-col justify-center">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg ${index === 0 ? 'bg-orange-500' : 'bg-green-500'
                        }`}>
                        03
                      </div>
                      <p className="text-[14px] font-[400]">
                        {index === 0 ? 'Days Running' : 'Total Days'}
                      </p>
                    </div>
                  </div>

                  {/* Tonnage and Location */}
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col leading-[15px]">
                      <p className="text-[14px]">Tonnage</p>
                      <p className="font-medium text-[14px]">
                        {index === 0 ? '36 Tons' : index === 1 ? '26 Tons' : '24 Tons'}
                      </p>
                    </div>
                    <div className="leading-[15px]">
                      <p className="text-[14px] ml-4 font-[300]">Chennai</p>
                      <div className="text-[16px] ml-6 text-[#F7941D] font-[600] flex items-center">
                        Chennai
                        <div className="text-[#F7941D] w-[25px] h-[25px]">
                          <SecureImage
                            fileKey={placeMareker}
                            alt="header icon"
                            width="25px"
                            className="w-full h-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CustomCard>
            ))}
          </div>
        </InfiniteScrollContainer>
      </div>

      {/* Right side - Selected card details */}
      <div className="flex-grow border-l-2 border-dashed p-4 overflow-hidden">
        <div className="flex justify-between items-center p-2 flex-wrap">
          <div className="leading-[15px] flex-1 min-w-0">
            <div
              className="flex items-center space-x-2"
              title=""
              style={{ cursor: "pointer" }}
            // onClick={() => navigate("view")}
            >
              {/* <SecureImage fileKey={document} alt="header icon" width="60px" /> */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 leading-[-15px]">
                  <p className="text-[#444FBD] text-[14px]  font-[600]">
                    CMA 8768787679799
                  </p>
                  <CustomChip
                    text="Waiting for clearance"
                    textColor="#FF973C"
                    backgroundColor="#FFF5EC"
                    borderColor="#FF973C"
                  />
                </div>
                <p className="text-[14px]  font-[400]">Empty to Warehouse</p>
                <p className="text-[14px]  font-[400]">30 July 2024, 06:16pm</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-end">
            <div className="flex items-center">
              <CircularProgress totalDays={5} />
              <p className="text-[14px] font-[400]">Days left</p>
            </div>
            <p className="text-[14px]">30 July 2024, 06:16pm</p>
          </div>
        </div>
        <br />
        <BaseToggle />
        <br />
        <br />
        <ContainerStatus />
        <br />
        <SurveyorDetails />
        <br />
        <div className="flex flex-col w-full">
          <div className="flex justify-between w-full p-2"></div>
          <div className="p-2 flex flex-col gap-4">
            <div className="flex items-center justify-between p-2 w-full flex-wrap gap-2">
              <p className="text-gray-700 text-sm font-medium">
                Route 1
              </p>
              <div className="border border-gray-300 rounded-lg px-4 py-2 flex-1 min-w-0 max-w-md">
                {isEditing ? (
                  <input
                    type="text"
                    name="route"
                    value={`${routeInfo.code} – ${routeInfo.start} – ${routeInfo.end}`}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className="text-black text-sm font-semibold w-full bg-transparent outline-none"
                    autoFocus
                  />
                ) : (
                  <p className="text-black text-sm font-semibold">
                    <span className="font-bold">{routeInfo.code}</span>{" "}
                    –{" "}
                    <span className="font-medium">
                      {routeInfo.start}
                    </span>{" "}
                    –{" "}
                    <span className="font-medium">{routeInfo.end}</span>
                  </p>
                )}
              </div>
              <CustomButton
                label=""
                icon={edit}
                onClick={handleEditClick}
              />
            </div>
          </div>
          <div className="flex items-start gap-4 flex-wrap">
            <div className="flex-1 min-w-0">
              <DeliveryTimeline />
            </div>
            <div className="flex-1 min-w-0 max-w-md h-[500px] rounded-[20px] mt-6 overflow-hidden relative">
              {/* LIVE MAP - SAME PATTERN AS TRIP DETAILS TAB */}
              {!isBlurred ? (
                <div className="w-full h-full">
                  <SimpleTripMap
                    tripId={tripId}
                    showMap={true}
                    onMapReady={() => console.log("🗺️ Cargo map is ready")}
                    trackingUrl={trackingUrl}
                  />
                </div>
              ) : (
                <div
                  className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-500 text-2xl font-semibold cursor-pointer"
                  onClick={ShowMap}
                >
                  Show Live Map
                </div>
              )}
            </div>
          </div>
        </div>
        <DocumentUpload />
      </div>
    </div>
  );
};

export default ContainerDetails;
